/**
 * Banners popup component
 *
 * @module app/components/banners/BannersPopup
 */
import jQuery from 'jquery';
import MessageBusTopics from '../../../common/MessageBusTopics';

/**
 * Binds event handlers to banner elements.
 *
 * @returns {void}
 *
 * @private
 */
var bindEvents = function bindEvents() {

    window.WH.messageBus.subscribe(MessageBusTopics.DEFERRED_LOAD_MAGNIFIC_POPUP, function () {

        jQuery('body').on('click', '.banners-container a.cpt-banner-enhanced__tcs', openTcs);

        jQuery(window).on('message onmessage', closeTcs);

    });
};

/**
 * Opens T&Cs page defined in href in
 * a popup using magnificPopup.
 *
 * @param   {Object} e jquery normalized event based on the browser
 *                   native event object.
 *
 * @returns {void}
 *
 * @private
 */
var openTcs = function tcsClickHandler(e) {

    jQuery.magnificPopup.open({
        items: {
            src: e.target.href,
        },
        type: 'iframe',
        mainClass: 'mfp-wrap--banners-popup',
    });

    e.preventDefault();
};

/**
 * Close the T&Cs popup.
 *
 * @param   {Object} e jquery normalized event based on the browser
 *                   native event object.
 *
 * @returns {void}
 *
 * @private
 */
var closeTcs = function tcsCloseHandler(e) {

    if (e.originalEvent.data === 'banners.tcs.close') {
        jQuery.magnificPopup.close();
    }

};

/**
 * Contains functions exposed by this component as an API.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Perform initialisation.
     *
     * @returns {void}
     *
     * @public
     */
    init: function init() {

        bindEvents();

    },

};

export default api;
